<template>
  <div id="app">
    <sb-header :isShowCheatSheet='isShowCheatSheet' @toggle-sheet=' isShowCheatSheet = !isShowCheatSheet '/>
    <sb-aside v-show='menuShow' />
    
    <div id="contents" class="clearfix" :class=' menuShow?"":"menu-hide" '>
      <router-view :class=' menuShow?"":"menu-hide" ' :style="{ fontSize: `${fontSize}em` }"/>
    </div>

    <sb-footer :class=' menuShow?"":"menu-hide" '/>
    <!-- <sb-banner /> -->
    <sb-csheet :isShowCheatSheet='isShowCheatSheet' @toggle-sheet=' isShowCheatSheet = !isShowCheatSheet ' />
  </div>
</template>

<script>
import EventBus from "@/eventbus.js";
import Header from "./layouts/Header.vue";
import Aside from "./layouts/Aside.vue";
import Footer from "./layouts/Footer.vue";
import FloatingBanner from "./views/FloatingBanner.vue";
import FloatingSheet from "./views/FloatingSheet.vue";

export default {
  name: "app",
  components: {
    "sb-aside": Aside,
    "sb-header": Header,
    "sb-footer": Footer,
    "sb-banner": FloatingBanner,
    "sb-csheet": FloatingSheet,
  },
  data(){
    return {
      isDevMode: false,
      menuShow: true,
      isShowCheatSheet: false,
      fontSize: 1.0
    }
  },
  methods: {
    // 메뉴 토글
    toggleMenu(){ this.menuShow = !this.menuShow } ,
    // 폰트 사이즈 조절용
    fontSizeUp(){ this.fontSize += 0.1; } ,
    fontSizeDown(){ this.fontSize -= 0.1; },
  },
  // @Override lifecycle
  created(){ 
    let url = window.location.href;
    if( url == undefined || url == null ) url = document.URL;
    this.isDevMode = url.startsWith('http://localhost:80');

    EventBus.$on("MENU_TOGGLE", () => { this.toggleMenu() });
    EventBus.$on("PAGE_FONT_SIZEUP", () => { this.fontSizeUp() });
    EventBus.$on("PAGE_FONT_SIZEDOWN", () => { this.fontSizeDown() });
  },
}
</script>

<style>
body { padding: 0; margin: 0;
  font-family: 'Nanum Gothic', monospace;
  /* font-family: 'Noto Sans KR', sans-serif; */
}
a, a:visited, a:link { text-decoration: none;}
.text-center { text-align: center; }
.text-right { text-align: right; }
.clerfix::after{ clear: both; content: ""; display: table; }


#contents {
  position: relative;
  margin-left: 300px;
  background-color: #f7f7f7;
  transition: .2s;
}
#contents.menu-hide {
  margin-left: 0;
}
</style>
